import logger from '@/modules/Logger';
import { store as localStore } from '@/utils/common';

// Returns the user's manually selected mic deviceId if it is in `mics`, else null
export function getManualMicId(userId, mics = []) {
  if (!userId || localStore.get(`mystage_micManual_${userId}`, null) !== 'true') {
    return null;
  }

  const savedId = localStore.get(`mystage_micId_${userId}`, null);
  const savedLabel = localStore.get(`mystage_micLabel_${userId}`, null);

  const byId = savedId ? mics.find(mic => mic.deviceId === savedId) : null;
  const byLabel = !byId && savedLabel ? mics.find(mic => mic.label === savedLabel) : null;
  const deviceId = (byId || byLabel)?.deviceId || null;
  const matchedBy = deviceId ? (byId ? 'id' : 'label') : null;

  logger.info('Manual mic restore check', {
    operation: 'devices:manual-mic-restore',
    restored: !!deviceId,
    matchedBy
  });

  return deviceId;
}
